import update from 'immutability-helper';
import { BlockStatus, BlockTypes } from '../../common/constants';
import { getNextBlockInOrder, buildSortedBlocksArray } from '../../common/utilities';
import { ActionTypes } from '../actions';
import { type IEnvelope, type IDocument, type IBlock, DateFormatType } from '../types';
import type { IBlockState } from './blocks';

export interface ISigningExperienceState {
  sortedBlocks: IBlock[];
  completedPassThrough: boolean;
  currentSelectedBlockIndex: number | null;
  dateFormat: DateFormatType;
}

const defaultSigningExperienceState = {
  sortedBlocks: [],
  completedPassThrough: false,
  currentSelectedBlockIndex: null,
  dateFormat: DateFormatType.Default,
};

export function signingExperienceReducer(state: ISigningExperienceState = defaultSigningExperienceState, action: any) {
  switch (action.type) {
    case ActionTypes.FETCH_ENVELOPE_DONE: {
      const envelope: IEnvelope = action.payload;
      const { serverTime } = action.payload;
      let blocks: IBlockState = {};
      envelope.documents.forEach((doc: IDocument) => {
        const docId = doc.documentId;
        if (!blocks[docId]) {
          blocks[docId] = {};
        }
        doc.blocks.forEach((block) => {
          if (!blocks[docId][block.pageNumber]) {
            blocks[docId][block.pageNumber] = {};
          }
          if (block.height && !block.fontSize) {
            block.fontSize = 12;
          }
          if (block.status === BlockStatus.COMPLETE) {
            block.signed = true;
            block.status = BlockStatus.COMPLETE;
          } else if (block.blockType === BlockTypes.DATE_SIGNED || block.blockType === BlockTypes.TIME_SIGNED) {
            block.value = serverTime;
            block.status = BlockStatus.COMPLETE;
          } else if (block.blockType === BlockTypes.FULLNAME) {
            // Full Name blocks are auto-populated, so set to Complete
            block.status = BlockStatus.COMPLETE;
          } else if (block.blockType === BlockTypes.CHECKBOX && block.value === null) {
            block.value! = false;
          }
          // TODO should TimeSigned be in this list?
          if (block.blockType !== 'DateSigned' && block.blockType !== 'FullName') {
            blocks[docId][block.pageNumber][block.blockId] = block;
          }
        });
      });
      const sortedBlocks = buildSortedBlocksArray(blocks);
      return update(state, {
        sortedBlocks: {
          $set: sortedBlocks,
        },
        dateFormat: { $set: envelope.config.dateFormat },
      });
    }

    case ActionTypes.TAB_NEXT_BLOCK: {
      const { currentIndex, blocks, groups, completedIndex } = action.payload;
      const { sortedBlocks, completedPassThrough } = state;
      const nextIndex = getNextBlockInOrder({
        currentIndex,
        blocks,
        sortedBlocks,
        completedPassThrough,
        groups,
        completedIndex,
      });
      if (nextIndex === 0 && currentIndex !== null) {
        return update(state, {
          currentSelectedBlockIndex: {
            $set: nextIndex,
          },
          completedPassThrough: {
            $set: true,
          },
        });
      }
      return update(state, {
        currentSelectedBlockIndex: {
          $set: nextIndex,
        },
      });
    }
    case ActionTypes.TAB_TO_BLOCK: {
      return update(state, {
        currentSelectedBlockIndex: {
          $set: action.payload.nextIndex,
        },
      });
    }
    case ActionTypes.SIGNING_EXPERIENCE_COMPLETE: {
      return update(state, {
        completedPassThrough: { $set: true },
      });
    }
    default: {
      return state;
    }
  }
}
